// eslint-disable-next-line
const omit = <T extends Record<string, any>, K extends keyof T>(
  obj: T,
  keysToOmit: K[],
): Omit<T, K> => {
  const filteredEntries = Object.entries(obj).filter(([key]) => !keysToOmit.includes(key as K));
  return Object.fromEntries(filteredEntries) as Omit<T, K>;
};

export default omit;
